import React from 'react';
import { useReducer } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Index from './pages/common/index';
import Workbench from './pages/workbench.js';
import NotInWexin from './pages/notInWexin.js';
import KChat from './pages/kchat.tsx';
import OrderDetail from './pages/orderDetail.jsx';
import OrderList from './pages/orderList.jsx';
import DeliveryList from './pages/deliveryList.jsx';
import ReceiveList from './pages/receiveList.js';
import ReceiveDetail from './pages/receiveDetail.jsx';
import StorageDetail from './pages/storageDetail.jsx';
import InquiryList from './pages/inquiryList.jsx';
import InquiryBidList from './pages/inquiryBidList.jsx';
import InquiryBidDetail from './pages/inquiryBidDetail.jsx';
import InquiryBidMultiList from './pages/inquiryBidMultiList.jsx';
import InquiryBidMultiDetail from './pages/inquiryBidMultiDetail.jsx';
import DeliveryDetail from './pages/deliveryDetail.jsx';
import InquiryDetail from './pages/inquiryDetail.jsx';
import InquiryQuoteDetail from './pages/inquiryQuoteDetail.jsx';
import AuthAdminLogin from './pages/authAdminLogin.js';
import StatisticsPurchaseOrder from './pages/statistics/purchaseOrder.js';
import SupplierList from './pages/supplierList.jsx';
import SupplierDetail from './pages/supplierDetail.jsx';
import SourcingList from './pages/sourcingList.jsx';
import SourcingDetail from './pages/sourcingDetail';
import Login from './pages/common/login';
import DingIot from './pages/common/dingIot';
import WorkWx from './pages/common/workWx';
import DingTalk from './pages/common/dingTalk';
import Register from './pages/common/register';
import CreateCompany from './pages/common/createCompany';
import MessageSetup from './pages/messageSetup';
import MessageDetail from './pages/messageDetail';
import Survey from './pages/survey';
import Personal from './pages/personal';
import StatisticsManagerialReport from './pages/statistics/managerialReport.js';
import ManagerialReportList from './pages/statistics/managerialReportList.js';
import OrderChangeList from './pages/orderChangeList.jsx';
import OrderChangeDetail from './pages/orderChangeDetail.jsx';
import annualSummary from './pages/annualSummary.js';
import OrderReportList from './pages/orderReportList.js';
import PlanTppBoard from './pages/planTppBoard.js';
import NotifyList from './pages/notifyList.js';
import NotifyDetail from './pages/notifyDetail.js';
import ApproveList from './pages/approveList.jsx';
import PricingList from './pages/pricingList.jsx';
import PricingDetail from './pages/pricingDetail.jsx';
import RequisitionList from './pages/requisitionList.jsx';
import RequisitionDetail from './pages/requisitionDetail.jsx';
import PriceCompareList from './pages/priceCompareList.jsx';
import PriceCompareDetail from './pages/priceCompareDetail.jsx';
import StatementList from './pages/billing/statementList';
import StatementDetail from './pages/billing/statementDetail';
import InvoiceList from 'pages/billing/invoiceList';
import InvoiceDetail from 'pages/billing/invoiceDetail.jsx';
import CostList from 'pages/billing/costList';
import CostDetail from 'pages/billing/costDetail';
import IqcList from 'pages/iqcList';
import IqcDetail from 'pages/iqcDetail';
import I8dReportList from 'pages/i8dReportList';
import I8dReportDetail from 'pages/i8dReportDetail';
import { initState, actionReducer, ActionContext } from './actions/context';
import InquiryBidFreightageList from './pages/inquiryBidFreightageList.jsx';
import InquiryBidFreightageDetail from './pages/inquiryBidFreightageDetail.jsx';
import BuyoffReportList from './pages/buyoffReportList.jsx';
import BuyoffReportDetail from './pages/buyoffReportDetail.jsx';
import OpportunityLeadList from './pages/opportunityLeadList.jsx';
import OpportunityLeadDetail from './pages/opportunityLeadDetail.jsx';
import EcnDetail from './pages/ecnDetail.jsx';
import EcnList from './pages/ecnList.jsx';
import ProdList from './pages/prodList.jsx';
import ProdDetail from './pages/prodDetail.jsx';
import SupplierAssessmentReportDetail from './pages/supplierAssessmentReportDetail.jsx';
import SupplierAssessmentReportList from './pages/supplierAssessmentReportList.jsx';
import DeliveryChangeList from './pages/deliveryChangeList.jsx';
import DeliveryChangeDetail from './pages/deliveryChangeDetail.jsx';
import PlanScheduleList from './pages/planScheduleList.jsx';
import PlanScheduleDetail from './pages/planScheduleDetail.jsx';
import PlanScheduleVendorDetail from './pages/planScheduleVendorDetail.jsx';
import MallIntroduceList from './pages/mallIntroduceList.jsx';
import MallIntroduceDetail from 'pages/mallIntroduceDetail.jsx';
import MallProdList from 'pages/mallProdList.jsx';
import PaymentList from './pages/paymentList.jsx';
import PaymentDetail from './pages/paymentDetail.jsx';
import PenaltyNoticeList from './pages/penaltyNoticeList.jsx';
import PenaltyNoticeDetail from './pages/penaltyNoticeDetail.jsx';
import PaymentApplyList from './pages/paymentApplyList.jsx';
import PaymentApplyDetail from './pages/paymentApplyDetail.jsx';
import InquiryProjectIfbList from './pages/inquiryProjectIfbList.jsx';
import InquiryProjectIfbDetail from './pages/inquiryProjectIfbDetail.jsx';
import InnerInquiryList from './pages/innerInquiryList.jsx';
import InnerInquiryDetail from './pages/innerInquiryDetail.jsx';
import IpLimit from './pages/common/ipLimit.jsx';
import VerifyLegalPerson from './pages/common/verifyLegalPerson.jsx';
import WwxCoprGroup from './pages/wwxCorpGroup.jsx';
import ReceiveAcceptanceList from './pages/receiveAcceptanceList.jsx';
import ReceiveAcceptanceDetail from './pages/receiveAcceptanceDetail.jsx';
import SupplierTerminateList from './pages/supplierTerminateList.jsx';
import SupplierTerminateDetail from './pages/supplierTerminateDetail.jsx';
import InfoChangeList from './pages/infoChangeList.jsx';
import InfoChangeDetail from './pages/infoChangeDetail.jsx';
import DeliveryDelayList from './pages/deliveryDelayList.jsx';
import DeliveryDelayDetail from './pages/deliveryDelayDetail.jsx';
import PaymentAdvanceList from './pages/paymentAdvanceList.jsx';
import PaymentAdvanceDetail from './pages/paymentAdvanceDetail.jsx';
import CustomerReceiveAsnList from './pages/customerReceiveAsnList.jsx';
import CustomerReceiveAsnDetail from './pages/customerReceiveAsnDetail.jsx';
import QuestionnaireList from './pages/questionnaireList.jsx';
import QuestionnaireDetail from './pages/questionnaireDetail.jsx';
import SaleDeliveryReturnList from 'pages/saleDeliveryReturnList.jsx';
import SaleDeliveryReturnDetail from 'pages/saleDeliveryReturnDetail.jsx';
import CustomerAdminReport from 'pages/statistics/customerAdminReport.js';
import PendingList from 'pages/pendingList2.jsx';
import P404 from './pages/404';
import ErrorPage from './pages/common/error.jsx';

function isWeixinBrowser(title) {
  if (typeof title === 'string') {
    document.title = title;
  }
  //let ua = navigator.userAgent.toLowerCase();
  // if (process.env.NODE_ENV === 'development') {
  //   //return true;
  // }
  //暂时不检测浏览器
  return true;
  //return /micromessenger/.test(ua) ? true : false;
}

//wrapping/composing
const AuthRoute = ({ title, type, component: Component, ...rest }) => {
  const [state, dispatch] = useReducer(actionReducer, initState);
  return (
    <ActionContext.Provider value={{ state, dispatch }}>
      <Route
        {...rest}
        render={props =>
          isWeixinBrowser(title) ? (
            <Component type={type} {...props} />
          ) : (
            <Redirect to="/mp/not" />
          )
        }
      />
    </ActionContext.Provider>
  );
};

const Root = ({ store }) => (
  <Provider store={store}>
    <Router>
      <div className="container">
        <AuthRoute exact path="/mp/" component={Index} title="协同工作台" />
        <AuthRoute
          exact
          path="/mp/index"
          component={Index}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/iplimit"
          component={IpLimit}
          title="IP登录限制"
        />
        <AuthRoute
          exact
          path="/mp/vlp/:authCode"
          component={VerifyLegalPerson}
          title="法人验证"
        />
        <AuthRoute
          exact
          path="/mp/workbench"
          component={Workbench}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/dingIot"
          component={DingIot}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/workWx"
          component={WorkWx}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/dingTalk"
          component={DingTalk}
          title="协同工作台"
        />
        {/* <AuthRoute
          exact
          path="/mp/wWwxCoprGroup"
          component={WwxCoprGroup}
          type="purchase"
          title="企微上下游"
        /> */}
        <AuthRoute
          exact
          path="/mp/login"
          component={Login}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/register"
          component={Register}
          title="协同工作台"
        />
        <AuthRoute
          exact
          path="/mp/create-company"
          component={CreateCompany}
          title="注册企业"
        />
        <AuthRoute
          exact
          path="/mp/authAdminLogin"
          component={AuthAdminLogin}
          title="携客云后台登陆授权"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/order/list"
          component={OrderList}
          type="sale"
          title="客户订单列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/order/list"
          component={OrderList}
          type="purchase"
          title="采购订单列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/order/detail/:companyCode/:id"
          component={OrderDetail}
          type="sale"
          title="客户订单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/order/detail/:companyCode/:id"
          component={OrderDetail}
          type="purchase"
          title="采购订单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/requisition/list"
          component={RequisitionList}
          type="purchase"
          title="请购单列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/requisition/detail/:companyCode/:id"
          component={RequisitionDetail}
          type="purchase"
          title="请购单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/vendorDelivery/list"
          component={DeliveryList}
          type="purchase"
          title="送货通知列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery/list"
          component={DeliveryList}
          type="sale"
          title="送货通知列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/vendorDelivery/detail/:companyCode/:id"
          component={DeliveryDetail}
          type="purchase"
          title="送货通知详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery/detail/:companyCode/:id"
          component={DeliveryDetail}
          type="sale"
          title="送货通知详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/receive/list"
          component={ReceiveList}
          type="purchase"
          title="采购收货"
        />
        <AuthRoute
          exact
          path="/mp/purchase/receive/detail/:companyCode/:id"
          component={ReceiveDetail}
          type="purchase"
          title="收货单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/storage/detail/:companyCode/:id"
          component={StorageDetail}
          type="purchase"
          title="入库单详情"
        />
        <AuthRoute
          exact
          path="/mp/statistics/purchase/order"
          component={StatisticsPurchaseOrder}
          type="sale"
          title="采购分析报表"
        />
        <AuthRoute
          exact
          path="/mp/statistics/purchase/monthlyReport/:companyCode/:id"
          component={StatisticsManagerialReport}
          type="purchase"
          title="管理报表推送"
        />
        <AuthRoute
          exact
          path="/mp/statistics/purchase/monthlyReport/list"
          component={ManagerialReportList}
          type="purchase"
          title="管理报表"
        />
        <AuthRoute
          exact
          path="/mp/statistics/sale/adminReport/:id"
          component={CustomerAdminReport}
          type="sale"
          title="供应商管理报表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/prod/list"
          component={InquiryList}
          type="purchase"
          title="物料询价招标列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/prod/list"
          component={InquiryList}
          type="sale"
          title="客户物料询价招标列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid/list"
          component={InquiryBidList}
          type="purchase"
          title="供应商竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid/list"
          component={InquiryBidList}
          type="sale"
          title="客户竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid-multi/list"
          component={InquiryBidMultiList}
          type="purchase"
          title="供应商多物料竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid-multi/list"
          component={InquiryBidMultiList}
          type="sale"
          title="客户多物料竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/prod/detail/:companyCode/:id"
          component={InquiryDetail}
          type="purchase"
          title="物料询价招标详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/prod/detail/:companyCode/:id"
          component={InquiryDetail}
          type="sale"
          title="客户询价招标详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid/detail/:companyCode/:id"
          component={InquiryBidDetail}
          type="purchase"
          title="供应商竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid/detail/:companyCode/:id"
          component={InquiryBidDetail}
          type="sale"
          title="客户竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid-multi/detail/:companyCode/:id"
          component={InquiryBidMultiDetail}
          type="purchase"
          title="供应商多物料竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid-multi/detail/:companyCode/:id"
          component={InquiryBidMultiDetail}
          type="sale"
          title="客户多物料竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/prod/quote/detail/:companyCode/:id/:code"
          component={InquiryQuoteDetail}
          type="purchase"
          title="物料询价招标记录详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/prod/quote/detail/:companyCode/:id/:code"
          component={InquiryQuoteDetail}
          type="sale"
          title="客户询价招标记录详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/prod/quote/add/:companyCode/:id"
          component={InquiryQuoteDetail}
          type="sale"
          title="客户询价招标-报价"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/list"
          component={SupplierList}
          type="purchase"
          title="供应商管理"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/detail/:companyCode/:id"
          component={SupplierDetail}
          type="purchase"
          title="供应商档案"
        />
        <AuthRoute
          exact
          path="/mp/purchase/sourcing/list"
          component={SourcingList}
          type="purchase"
          title="潜在供应商"
        />
        <AuthRoute
          exact
          path="/mp/purchase/sourcing/detail/:companyCode/:id"
          component={SourcingDetail}
          type="purchase"
          title="潜在供应商档案"
        />
        <AuthRoute
          exact
          path="/mp/message/setup"
          component={MessageSetup}
          title="设置微信消息"
        />
        <AuthRoute
          exact
          path="/mp/message/detail/:companyCode/:id"
          component={MessageDetail}
          type="messageDetail"
          title="消息详情"
        />
        <AuthRoute
          exact
          path="/mp/personal"
          component={Personal}
          title="设置用户信息"
        />
        <AuthRoute
          exact
          path="/mp/survey/:id"
          component={Survey}
          title="供应链评测"
        />
        <AuthRoute
          exact
          path="/mp/purchase/change/list"
          component={OrderChangeList}
          type="purchase"
          title="采购变更列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/change/list"
          component={OrderChangeList}
          type="sale"
          title="客户变更列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/change/detail/:companyCode/:id"
          component={OrderChangeDetail}
          type="sale"
          title="客户变更详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/change/detail/:companyCode/:id"
          component={OrderChangeDetail}
          type="purchase"
          title="采购变更详情"
        />
        <AuthRoute
          exact
          path="/mp/annual-summary"
          component={annualSummary}
          type="purchaseChange"
          title="2020年度总结"
        />
        <AuthRoute
          exact
          path="/mp/purchase/order/report/list"
          component={OrderReportList}
          type="purchaseOrderReport"
          title="订单执行进度"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/report/list"
          component={OrderReportList}
          type="customerOrderReport"
          title="订单执行进度"
        />
        <AuthRoute
          exact
          path="/mp/purchase/plan/tpp/board"
          component={PlanTppBoard}
          type="purchasePlanTppBoard"
          title="订单直运看板"
        />
        <AuthRoute
          exact
          path="/mp/sale/plan/tpp/board"
          component={PlanTppBoard}
          type="customerPlanTppBoard"
          title="订单直运看板"
        />
        <AuthRoute
          exact
          path="/mp/notify/list/2"
          component={NotifyList}
          type="supplierNotify"
          title="供应商通知"
        />
        <AuthRoute
          exact
          path="/mp/notify/list/1"
          component={NotifyList}
          type="customerNotify"
          title="客户通知"
        />
        <AuthRoute
          exact
          path="/mp/notify/detail/:type/:companyCode/:id"
          component={NotifyDetail}
          type="notifyDetail"
          title="企业通知详情"
        />
        <AuthRoute
          exact
          path="/mp/management/workflow/approve/list"
          component={ApproveList}
          type="purchase"
          title="业务审批"
        />
        <AuthRoute
          exact
          path="/mp/purchase/pricing/list"
          component={PricingList}
          type="purchase"
          title="核价单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/pricing/detail/:companyCode/:id"
          component={PricingDetail}
          type="purchase"
          title="核价单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/quote-compare/list"
          component={PriceCompareList}
          type="purchase"
          title="比价单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/quote-compare/detail/:companyCode/:id"
          component={PriceCompareDetail}
          type="purchase"
          title="比价单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/statement/list"
          component={StatementList}
          type="purchase"
          title="供应商对账单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/iqc/list"
          component={IqcList}
          type="purchase"
          title="来料检验单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/iqc/detail/:companyCode/:id"
          component={IqcDetail}
          type="purchase"
          title="来料检验单详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/statement/list"
          component={StatementList}
          type="sale"
          title="客户对账单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/statement/detail/:companyCode/:id"
          component={StatementDetail}
          type="purchase"
          title="供应商对账单详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/statement/detail/:companyCode/:id"
          component={StatementDetail}
          type="sale"
          title="客户对账单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/cost/list"
          component={CostList}
          type="purchase"
          title="供应商费用单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/cost/detail/:companyCode/:id"
          component={CostDetail}
          type="purchase"
          title="供应商费用单详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/cost/list"
          component={CostList}
          type="sale"
          title="客户费用通知"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/cost/detail/:companyCode/:id"
          component={CostDetail}
          type="sale"
          title="客户费用单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/invoice/list"
          component={InvoiceList}
          type="purchase"
          title="供应商发票"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/invoice/list"
          component={InvoiceList}
          type="sale"
          title="客户发票通知"
        />
        <AuthRoute
          exact
          path="/mp/purchase/billing/invoice/detail/:companyCode/:id"
          component={InvoiceDetail}
          type="purchase"
          title="供应商发票详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/billing/invoice/detail/:companyCode/:id"
          component={InvoiceDetail}
          type="sale"
          title="供应商发票详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/iqc/list"
          component={IqcList}
          type="sale"
          title="送货不良记录"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/iqc/detail/:companyCode/:id"
          component={IqcDetail}
          type="sale"
          title="客户来料检验单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/iqc/8d-report/list"
          component={I8dReportList}
          type="purchase"
          title="8D报告"
        />
        <AuthRoute
          exact
          path="/mp/purchase/iqc/8d-report/detail/:companyCode/:id"
          component={I8dReportDetail}
          type="purchase"
          title="8D报告详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/iqc/8d-report/list"
          component={I8dReportList}
          type="sale"
          title="8D报告"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/iqc/8d-report/detail/:companyCode/:id"
          component={I8dReportDetail}
          type="sale"
          title="8D报告详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid/freightage/list"
          component={InquiryBidFreightageList}
          type="purchase"
          title="供应商物流竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid/freightage/list"
          component={InquiryBidFreightageList}
          type="sale"
          title="客户物流竞价列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/bid/freightage/detail/:companyCode/:id"
          component={InquiryBidFreightageDetail}
          type="purchase"
          title="供应商物流竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/bid/freightage/detail/:companyCode/:id"
          component={InquiryBidFreightageDetail}
          type="sale"
          title="客户物流竞价详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/buyoff-report/list"
          component={BuyoffReportList}
          type="purchase"
          title="物料准入报告列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/buyoff-report/list"
          component={BuyoffReportList}
          type="sale"
          title="物料准入报告列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/buyoff-report/detail/:companyCode/:id"
          component={BuyoffReportDetail}
          type="purchase"
          title="物料准入报告详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/buyoff-report/detail/:companyCode/:id"
          component={BuyoffReportDetail}
          type="sale"
          title="物料准入报告详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/opportunity-management/lead/list"
          component={OpportunityLeadList}
          type="sale"
          title="商机线索列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/opportunity-management/lead/detail/:companyCode/:id"
          component={OpportunityLeadDetail}
          type="sale"
          title="商机线索详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/ecn/list"
          component={EcnList}
          type="purchase"
          title="ECN报告列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/ecn/list"
          component={EcnList}
          type="sale"
          title="ECN报告列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/ecn/detail/:companyCode/:id"
          component={EcnDetail}
          type="purchase"
          title="ECN报告详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/ecn/detail/:companyCode/:id"
          component={EcnDetail}
          type="sale"
          title="ECN报告详情"
        />
        <AuthRoute
          exact
          path="/mp/management/basic-data/prod/list"
          component={ProdList}
          type="purchase"
          title="企业物料"
        />
        <AuthRoute
          exact
          path="/mp/management/basic-data/prod/detail/:companyCode/:id"
          component={ProdDetail}
          type="purchase"
          title="企业物料"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/assessment-report/list"
          component={SupplierAssessmentReportList}
          type="purchase"
          title="供应商准入评估列表"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/assessment-report/list"
          component={SupplierAssessmentReportList}
          type="sale"
          title="客户准入评估列表"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/assessment-report/detail/:companyCode/:id"
          component={SupplierAssessmentReportDetail}
          type="purchase"
          title="供应商准入评估详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/assessment-report/detail/:companyCode/:id"
          component={SupplierAssessmentReportDetail}
          type="sale"
          title="客户准入评估详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/delivery-change/list"
          component={DeliveryChangeList}
          type="purchase"
          title="交料通知"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery-change/list"
          component={DeliveryChangeList}
          type="sale"
          title="客户交料通知"
        />
        <AuthRoute
          exact
          path="/mp/purchase/delivery-change/detail/:companyCode/:id"
          component={DeliveryChangeDetail}
          type="purchase"
          title="交料通知详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery-change/detail/:companyCode/:id"
          component={DeliveryChangeDetail}
          type="sale"
          title="交料通知详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/plan/schedule/list"
          component={PlanScheduleList}
          type="purchase"
          title="供应计划排程"
        />
        <AuthRoute
          exact
          path="/mp/sale/plan/schedule/list"
          component={PlanScheduleList}
          type="sale"
          title="客户交货排程"
        />
        <AuthRoute
          exact
          path="/mp/purchase/plan/schedule/detail/:companyCode/:id"
          component={PlanScheduleDetail}
          type="purchase"
          title="供应计划排程详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/plan/schedule/detail/:companyCode/:id"
          component={PlanScheduleDetail}
          type="sale"
          title="客户交货排程详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/plan/schedule/vendor/detail/:companyCode/:id"
          component={PlanScheduleVendorDetail}
          type="purchase"
          title="供应商交货排程详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/mall/introduce-list"
          component={MallIntroduceList}
          type="purchase"
          title="内部商城引入单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/mall/introduce-detail/:companyCode/:id"
          component={MallIntroduceDetail}
          type="purchase"
          title="内部商城引入单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/mall/prod-list"
          component={MallProdList}
          type="purchase"
          title="企业内部商城"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/order/list"
          component={PaymentList}
          type="purchase"
          title="付款单"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/order/detail/:companyCode/:id"
          component={PaymentDetail}
          type="purchase"
          title="付款单详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/penalty-notice/list"
          component={PenaltyNoticeList}
          type="purchase"
          title="供应商违约/索赔通知"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/penalty-notice/list"
          component={PenaltyNoticeList}
          type="sale"
          title="供应商违约/索赔通知"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/penalty-notice/detail/:companyCode/:id"
          component={PenaltyNoticeDetail}
          type="purchase"
          title="供应商违约/索赔通知详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/penalty-notice/detail/:companyCode/:id"
          component={PenaltyNoticeDetail}
          type="sale"
          title="供应商违约/索赔通知详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/apply/list"
          component={PaymentApplyList}
          type="purchase"
          title="付款申请"
        />
        <AuthRoute
          exact
          path="/mp/sale/cust-payment/apply/list"
          component={PaymentApplyList}
          type="sale"
          title="付款申请"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/apply/detail/:companyCode/:id"
          component={PaymentApplyDetail}
          type="purchase"
          title="付款申请详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/cust-payment/apply/detail/:companyCode/:id"
          component={PaymentApplyDetail}
          type="sale"
          title="付款申请详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/project/ifb/list"
          component={InquiryProjectIfbList}
          type="purchase"
          title="项目招标"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/project/ifb/list"
          component={InquiryProjectIfbList}
          type="sale"
          title="项目招标"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/project/ifb/detail/:companyCode/:id"
          component={InquiryProjectIfbDetail}
          type="purchase"
          title="项目招标详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/inquiry/project/ifb/detail/:companyCode/:id"
          component={InquiryProjectIfbDetail}
          type="sale"
          title="项目招标详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/inner/list"
          component={InnerInquiryList}
          type="purchase"
          title="询价需求"
        />
        <AuthRoute
          exact
          path="/mp/purchase/inquiry/inner/detail/:companyCode/:id"
          component={InnerInquiryDetail}
          type="purchase"
          title="询价需求详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/receive/acceptance/list"
          component={ReceiveAcceptanceList}
          type="purchase"
          title="采购验收"
        />
        <AuthRoute
          exact
          path="/mp/purchase/receive/acceptance/detail/:companyCode/:id"
          component={ReceiveAcceptanceDetail}
          type="purchase"
          title="采购验收详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/terminate/list"
          component={SupplierTerminateList}
          type="purchase"
          title="供应商清退"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/terminate/detail/:companyCode/:id"
          component={SupplierTerminateDetail}
          type="purchase"
          title="供应商清退详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/info-change/list"
          component={InfoChangeList}
          type="purchase"
          title="供应商信息变更"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/my-info-change/list"
          component={InfoChangeList}
          type="sale"
          title="企业信息变更"
        />
        <AuthRoute
          exact
          path="/mp/purchase/supplier/info-change/detail/:companyCode/:id"
          component={InfoChangeDetail}
          type="purchase"
          title="供应商信息变更详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/my-info-change/detail/:companyCode/:id"
          component={InfoChangeDetail}
          type="sale"
          title="企业信息变更详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/delivery-delay/list"
          component={DeliveryDelayList}
          type="purchase"
          title="延迟送货申请"
        />
        <AuthRoute
          exact
          path="/mp/purchase/delivery-delay/detail/:companyCode/:id"
          component={DeliveryDelayDetail}
          type="purchase"
          title="延迟送货申请详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery-delay/list"
          component={DeliveryDelayList}
          type="sale"
          title="延迟送货申请"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery-delay/detail/:companyCode/:id"
          component={DeliveryDelayDetail}
          type="sale"
          title="延迟送货申请详情"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/advance/list"
          component={PaymentAdvanceList}
          type="purchase"
          title="预付款"
        />
        <AuthRoute
          exact
          path="/mp/sale/cust-payment/advance/list"
          component={PaymentAdvanceList}
          type="sale"
          title="客户预付款"
        />
        <AuthRoute
          exact
          path="/mp/purchase/payment/advance/detail/:companyCode/:id"
          component={PaymentAdvanceDetail}
          type="purchase"
          title="预付款详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/cust-payment/advance/detail/:companyCode/:id"
          component={PaymentAdvanceDetail}
          type="sale"
          title="预付款详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer-receive/asn/list"
          component={CustomerReceiveAsnList}
          type="sale"
          title="客供料代收"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer-receive/asn/detail/:companyCode/:id"
          component={CustomerReceiveAsnDetail}
          type="sale"
          title="客供料代收详情"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery/return/list"
          component={SaleDeliveryReturnList}
          type="sale"
          title="客户退货"
        />
        <AuthRoute
          exact
          path="/mp/sale/delivery/return/detail/:companyCode/:id"
          component={SaleDeliveryReturnDetail}
          type="sale"
          title="客户退货详情"
        />
        <AuthRoute
          exact
          path="/mp/pending/list/:type"
          type="purchase"
          component={PendingList}
          title="待处理|待跟进任务"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/questionnaire/list"
          component={QuestionnaireList}
          type="sale"
          title="客户问卷"
        />
        <AuthRoute
          exact
          path="/mp/sale/customer/questionnaire/detail/:companyCode/:customerCode/:id/:questionnaireCode"
          component={QuestionnaireDetail}
          type="sale"
          title="客户问卷详情"
        />
        <AuthRoute exact path="/mp/kchat" component={KChat} title="在线客服" />
        <AuthRoute exact path="/mp/404" component={ErrorPage} type="404" />
        <AuthRoute exact path="/mp/pc" component={ErrorPage} type="pc" />
        <AuthRoute exact path="/mp/pc/:a/:b" component={ErrorPage} type="pc" />
        <AuthRoute
          exact
          path="/mp/pc/:a/:b/:c"
          component={ErrorPage}
          type="pc"
        />
        <Route exact path="/mp/not" component={ErrorPage} />
      </div>
    </Router>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;
